<template>
  <div :class="`questionDetail ${item.answer_record ? 'answered':''}`" v-if="question_data">
    <div class="problemView">
        <span class="message">{{question_data.message}}</span>
        <img v-if="question_data.hasOwnProperty('image') && question_data.image" class="photo" :src="question_data.image" @click.stop="bigImage(question_data.image)"/>
    </div>
    <div class="optionView">
        <div class="options">
            <div class="option" v-for="(newItem, index) in question_data.options" :key="index">
                <div :class="`optionWrapper ${item.answer_record && item.answer_record.user_answer.includes(newItem.number)  ? 'answered':''}`">
                    <span class="number">{{newItem.number}}</span>
                    <span class="message">{{newItem.message}}</span>
                    <img v-if="newItem.image" class="photo" :src="newItem.image" @click.stop="bigImage(newItem.image)"/>
                </div>
                <img v-if="item.answer_record && (item.answer_record.user_answer.includes(newItem.number) || question_data.answer.includes(newItem.number))" class="icon" :src="`${question_data.answer.includes(newItem.number) ? images.right: images.wrong}`" />
                <img v-else class="icon" :src="images.blank" @click="selectOption(newItem.number)"/>
            </div>
        </div>
    </div>
    <div :class="`tip ${item.answer_right_count >= question_data.diamond.count?'finish':''}`" v-if="question_data.diamond.value !== 0">此题答对有奖励({{item.answer_right_count > question_data.diamond.count ? question_data.diamond.count : item.answer_right_count}}/{{question_data.diamond.count}})</div>
    <!-- 全屏图片浏览视图 -->
    <PreviewPhotos ref="shadowPhotos" />
  </div>
</template>

<script>

import { 
  IMG_QUESTION_SELECT, 
  IMG_QUESTION_WRONG,
  IMG_QUESTION_UNSELECT
} from '../../assets';

import PreviewPhotos from './PreviewPhotos.vue';

import { types as LoginTypes } from "@/store/modules/login";
import { types as ToastTypes } from "@/store/modules/toast";
import { types as CommunityTypes } from "@/store/modules/community";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "QuestionDetail",
  components: {
    PreviewPhotos,
  },
  props: {
    item: {
      type: Object
    }
  },
  data() {
    return {
      images:{
        right: IMG_QUESTION_SELECT,
        wrong: IMG_QUESTION_WRONG,
        blank: IMG_QUESTION_UNSELECT
      },
      question_data: null,
    };
  },
  watch: {},
  computed: {},
  methods: {
    ...mapMutations({
      showToast: ToastTypes.SHOW
    }),
    ...mapActions({
      dependLoginStatus: LoginTypes.LOAD_LOGIN_STATUS,
      fetchAnswerQuestion: CommunityTypes.FETCH_ANSWER_QUESTION
    }),

    //选择一个选项
    selectOption(number){
      let callback = ()=>{
      if(this.item.answer_record){
        // this.showToast({"message":"你己经作答过了"})
        return
      }
      let user_answer = [number];
      let dic = {"post_id":this.item.pk, "user_answer":user_answer}
      this.fetchAnswerQuestion(dic);
      }
      this.dependLoginStatus().then(callback)
    },
    // 图片放大查看
    bigImage(url){
      this.$refs.shadowPhotos.showShadowView([url])
    },

  },
  created() {},
  destroyed() {},
  mounted() {
    this.question_data = JSON.parse(this.item.question_json);
  }
};
</script>

<style lang="less" scoped>
.questionDetail {
  background-color: #f2f2f5;
  padding: 10px;
  padding-top: 15px;
  border-radius: 5px;
  overflow: auto;
  .problemView{
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 10px;
    .message{
      color: #333333;
      font-size: 14px;
      line-height: 23px;
    }
    .photo{
      // width: 40px;
      cursor: pointer;
      height: 40px;
      margin-left: 10px;
    }
  }
  .optionView{
    display: flex;
    flex-direction: row;
    .options{
      flex: 1;
      .option{
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 10px;
        .optionWrapper{
          flex: 1;
          display: flex;
          flex-direction: row;
          align-items: center;
          // height: 40px;
          background-color: #ffffff;
          border: solid 1px #EBEBEB;
          padding: 0 5px;
          border-radius: 3px;
          position: relative;
          .number{
            color: #774EE5;
            font-size: 16px;
            margin-right: 5px;
          }
          .message{
            font-size: 14px;
            color: #333333;
            line-height: 23px;
            margin: 5px 0;
            word-wrap: break-word;
            word-break: break-word;
          }
          .photo{
            // width: 40px;
            cursor: pointer;
            height: 40px;
            margin-left: 10px;
          }
        }
        .icon{
          // width: 15px;
          // height: 15px;
          // position: absolute;
          // right: 5px;
          width: 25px;
          height: 25px;
          margin-left: 10px;
          cursor: pointer;
        }
      }
      
    }
  }
  .tip{
    color: #6B45E1;
    font-size: 12px;
    &.finish{
      color: #999999;
    }
  }
  &.answered{
    .optionView .options .option .optionWrapper.answered{
      background-color: #FDE2C9;
      border-color: #FF7B00;
    }
    .optionView .options .option .optionWrapper .number{
      color: #FF7B00;
    }
  }
}

</style>
